import Joi from "joi";
import { customMessages } from "./messages";

function ValidatePurchaseMoviment(purchaseMoviment) {
  const schema = Joi.object({
    idProduto: Joi.alternatives().conditional('tipoProduto', {
      is: 'agrotoxico',
      then: Joi.string()
        .uuid({ version: 'uuidv4' })
        .optional()
        .allow(null, ''),
      otherwise: Joi.string()
        .uuid({ version: 'uuidv4' })
        .required()
        .messages(customMessages.idProduto)
    }),
    idCompra: Joi.string().uuid({ version: 'uuidv4' }).messages(customMessages.idCompra),
    quantidade: Joi.number().required().messages(customMessages.quantidade),
    valorUnitario: Joi.number().required().messages(customMessages.valorUnitario),
    tipoProduto: Joi.valid('normal', 'agrotoxico').required().messages(customMessages.tipoProduto).required(),

    agrotoxico: Joi.when(Joi.ref('..tipoProduto'), {
      is: 'agrotoxico',
      then: Joi.object({
        idAgrotoxico: Joi.number().required().messages(customMessages.idAgrotoxico),
        agrotoxico: Joi.string().required().messages(customMessages.agrotoxico),
        idEmbalagem: Joi.number().allow('', null).optional(),
        embalagem: Joi.string().required().messages(customMessages.embalagem),
        registroAgrotox: Joi.string().required().messages(customMessages.registroAgrotox),
        lote: Joi.string().allow('', null).optional()
      }).required().messages({
        'any.required': '(Informações do agrotóxico) são obrigatórias'
      }),
      otherwise: Joi.object({
        idAgrotoxico: Joi.number().allow('', null).optional(),
        agrotoxico: Joi.string().allow('', null).optional(),
        idEmbalagem: Joi.number().allow('', null).optional(),
        embalagem: Joi.string().allow('', null).optional(),
        registroAgrotox: Joi.string().allow('', null).optional(),
        lote: Joi.string().allow('', null).optional()
      }).optional()
    })
  }).unknown(true)

  const { error } = schema.validate(purchaseMoviment, { abortEarly: false })

  if (error?.details && error?.details.length) {
    const errors = error?.details.map(erro => {
      if (erro?.message || erro?.path[0]) {
        if (erro.path.length > 1) {
          return {
            message: erro?.message,
            keyError: erro?.path[1],
            type: erro.type.split('.')[1]
          }
        }

        return {
          message: erro?.message,
          keyError: erro?.path[0],
          type: erro.type.split('.')[1]
        }
      }
    })

    return errors
  }
}

export { ValidatePurchaseMoviment }